import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { TimesIcon } from 'ui/Icons/components/Times.component';
import { theme } from '../../../tailwind.config';

export interface IMultiSearchTagProps {
  value: string;
  label: string;
  className?: string;
  onDelete: (value: string) => void;
}

export const MultiSearchTag: React.FC<IMultiSearchTagProps> = React.memo(
  ({
    value,
    label,
    onDelete,
    className,
  }) => {
    const handleDelete = useCallback(() => {
      onDelete(value);
    }, [onDelete, value]);

    return (
      <div className={classnames('multisearch-tag flex items-center justify-between bg-gray-10 p-[5px] rounded', className)}>
        <span className="font-pt-sans text-[15px] leading-[19px] text-black">{label}</span>
        <span className='ml-[10px]' onClick={handleDelete}>
          <TimesIcon icon={theme.colors['brown-100']} />
        </span>
      </div>
    );
  }
);
